<template>
  <div :class="classObj" class="app-wrapper">
    <div
      v-if="(phoneFlag ? true : false) && !$store.state.Config.menuCollapse"
      class="drawer-bg"
      @click="handleClickOutside"
    />
    <sidebar :sidebarData="sidebarData" class="sidebar-container"></sidebar>

    <div :class="{ hasTagsView: false }" class="main-container">
      <div :class="{ 'fixed-header': fixedHeader }">
        <headercpn></headercpn>
      </div>

      <section class="app-main">
        <transition name="fade-transform" mode="out-in">
          <el-main>
            <h2 style="padding: 0 0 20px 0;">
              {{ $t("app.router." + $route.name) }}
            </h2>
            <!-- <el-divider v-if="!phoneFlag"></el-divider> -->
            <router-view></router-view>
          </el-main>
          <!-- <div class="scroll-bar">
            <h2>
              {{ $t("app.router." + $route.name) }}
            </h2>
            <el-divider v-if="!phoneFlag"></el-divider>
            <router-view></router-view>
          </div> -->
        </transition>
      </section>
    </div>
  </div>
</template>
<script>
import Sidebar from "@/components/layout/Sidebar";
import Headercpn from "@/components/layout/Header";
import { getRouter } from "@/api/resource";
import { obj } from "@/utils/sidebar.js";
export default {
  components: {
    Sidebar,
    Headercpn,
  },
  data() {
    return {
      sidebarData: [],
      loading: false,
      phoneFlag: false,
      withoutAnimation: false,
      fixedHeader: true,
    };
  },
  created() {
    this.init();
  },

  computed: {
    classObj() {
      return {
        hideSidebar: this.$store.state.Config.menuCollapse,
        openSidebar: !this.$store.state.Config.menuCollapse,
        withoutAnimation: this.withoutAnimation,
        mobile: this.phoneFlag ? "mobile" : undefined,
      };
    },
  },
  mounted() {
    if(this.phoneFlag){
      this.$store.commit("Config/set_menuCollapse", true);
    }
  },
  methods: {
    handleClickOutside() {
      this.withoutAnimation = true;
      this.$store.commit(
        "Config/set_menuCollapse",
        !this.$store.state.Config.menuCollapse
      );
    },
    //返回true表示为pc端打开，返回false表示为手机端打开
    isPhone() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      this.isMobile = flag === null;
      this.$store.commit("Config/set_device", this.isMobile);
      return flag;
    },
    init() {
      this.phoneFlag = this.isPhone();
      this.withoutAnimation = !this.phoneFlag;
      // this.fixedHeader = this.phoneFlag ? true : false;
      // this.$store.commit("Config/set_menuCollapse", !this.fixedHeader)
      if (this.$store.state.Config.studentType === "new") {
        this.sidebarData = [
          {
            MenuCode: "menu_index",
            MenuName: "home",
            Url: "/newStu",
            Subset: [],
          },
          {
            MenuCode: "menu_application",
            MenuName: "applicationForAccommodation",
            Url: "/apply",
            Subset: [],
          },
        ];
      } else if (this.$store.state.Config.studentType === "old") {
        this.sidebarData = [
          {
            MenuCode: "menu_index",
            MenuName: "home",
            Url: "/oldStu",
            Subset: [],
          },
          {
            MenuCode: "menu_application",
            MenuName: "applicationForAccommodation",
            Url: "/applyOld",
            Subset: [],
          },
          {
            MenuCode: "menu_overnight",
            MenuName: "nightReturnRegistration",
            Url: "/overnight",
            Subset: [],
          },
          {
            MenuCode: "menu_return_in_night",
            MenuName: "returnInNight",
            Url: "/returnInNight",
            Subset: [],
          },
          {
            MenuCode: "menu_hostel_checkout_reservation",
            MenuName: "hostelCheckoutReservation",
            Url: "/hostelCheckoutReservation",
            Subset: [],
          },
        ];
      } else {
        this.sidebarData = [];
        this.loadingScreen();
        getRouter().then((res) => {
          this.sidebarData = res.data
            .map((item) => {
              this.loading.close();
              return {
                MenuCode: this.getProp(obj[item.MenuCode], "MenuCode"),
                MenuName: this.getProp(obj[item.MenuCode], "MenuName"),
                Url: this.getProp(obj[item.MenuCode], "Url"),
                Subset: item.Subset.map((i) => {
                  return {
                    MenuCode: this.getProp(obj[i.MenuCode], "MenuCode"),
                    MenuName: this.getProp(obj[i.MenuCode], "MenuName"),
                    Url: this.getProp(obj[i.MenuCode], "Url"),
                  };
                }).filter((_) => _.MenuCode !== ""),
              };
            })
            .filter((_filter) => _filter.MenuCode !== "");
        });
      }
    },
    getProp(obj, str) {
      if (!obj) {
        return "";
      }
      return obj[str] || "";
    },
    loadingScreen() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";
/*@import "~@/styles/sidebar.scss";*/
.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 60px);
  width: 100%;
  position: relative;
  overflow: hidden;
}
.fixed-header + .app-main {
  padding-top: 60px;
}
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
  background-color: #ffffff;
}

.backstage {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
<style lang="scss">
.backstage {
  .el-divider--horizontal {
    margin: 15px 0;
  }
}
</style>
